module.exports = __webpack_public_path__ + "static/media/5.7d49c77a.jpg";